import Card from "components/card";
import { FooterDivider } from "flowbite-react";
import { useState } from "react";
import { EmailService } from "service/emailService";

interface FormErrors {
  studentName?: string;
  parentName?: string;
  email?: string;
  phone?: string;
  grade?: string;
}

// A simple formatter function. A real-world app would need more robust logic.
const formatPhoneNumber = (value: string): string => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3,6)}-${phoneNumber.slice(6, 10)}`;
};

function Notification() {
  const [phoneValue, setPhoneValue] = useState("");
   const [formData, setFormData] = useState({
        from_name: '',
        from_parent_name:'',
        from_email: '',
        phone: '',
        grade:'',
        message: '',
        title:''
      });
  const [status, setStatus] = useState('');
  const [errors, setErrors] = useState<FormErrors>({});
  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setPhoneValue(formattedPhoneNumber);
    formData.phone = formattedPhoneNumber;
    formData.title = "Consultation Request";
    setFormData(formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    if(e.target.name==="from_student_name"){
      if(e.target.value.trim()===""){
        formData.from_name = '';
      } else {
        formData.from_name = e.target.value;
      }
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const validateForm = () => {
    const newErrors: FormErrors = {};
    if (!formData.from_name || formData.from_name.trim() === '') {
      newErrors.studentName = 'Student Name is required.';
    }else {
      newErrors.studentName = '';
    } 
    if (!formData.from_parent_name.trim()) {
      newErrors.parentName = 'Parent Name is required.';
    } else {
      newErrors.parentName = '';
    }
    if (!formData.from_email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.from_email)) {
      newErrors.email = 'Invalid email format.';
    }else {
      newErrors.email = '';
    }

    if (!phoneValue.trim()) {
      newErrors.phone = 'Phone number is required.';
    } else if (phoneValue.replace(/[^\d]/g, '').length !== 10) {
      newErrors.phone = 'Phone number must be 10 digits.';
    } else {
      newErrors.phone = '';
    }
    if (!formData.grade.trim()) {
      newErrors.grade = 'Grade is required.';
    } else {
      newErrors.grade = '';
    }
    setErrors(newErrors);
    console.log(newErrors);
  if(formData.from_name && formData.from_parent_name && formData.from_email && phoneValue && formData.grade && Object.values(newErrors).every(error => error === '')) {
      return true;
  } else {
    return false;
  }
};

   const handleSubmit = async (e: React.FormEvent) => {
     e.preventDefault();
     
      if (!validateForm()) {
        setStatus('Failure');
        return;
      }
       try {
          await EmailService.sendEmail(formData,'template_pvh1mj3');
          setStatus('Success');
         // await EmailService.sendEmail(formData,'template_mfkks5m');

         // Add a delay before clearing the form
          setTimeout(() => {
             setFormData({ from_name: '', from_email: '', from_parent_name: '', phone:'',grade:'', message:'', title:'' }); // Clear form
          }, 3000); // 3-second delay
        
        } catch (error) {
          setStatus('Failed to send email.');
        }
      };

  return (
    <Card extra={"w-full h-full p-3"}>
      <div className="to-transparent relative  mb-3 mt-1 content-center items-center justify-between rounded bg-gradient-to-b from-indigo-200 pt-1  text-center">
        <h4 className="mt-3 text-xl font-bold text-navy-600 dark:text-white">
          Ready to Get Started?
        </h4>
        <h3>Schedule a free consultation to discuss your student's needs </h3>
      </div>
      <FooterDivider></FooterDivider>
      <div className="mt-8 flex flex-col ">
        {/* Success Alert */} 
        { status === 'Success' && (
          <div id="alert-border-1" className="flex items-center p-4 mb-4 text-green-800 border-t-4 border-green-300 bg-green-50 dark:text-green-400 dark:bg-gray-800 dark:border-green-800" role="alert">
          <svg className="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <div className="ms-3 text-sm font-medium">
              Thank you for your email. We appreciate the time you took to reach out to us and will respond shortly.
           </div>
          </div>
          )} 
        { status === 'Failure' && (
          <div id="alert-border-1" className="flex items-center p-4 mb-4 text-red-800 border-t-4 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800" role="alert">
          <svg className="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
          </svg>
          <div className="ms-3 text-sm font-medium">
              Please fix the errors in the form before submitting.
            </div>
          </div>
          )}
        <form>
          <div className="ml-20 mr-20 flex ">
            <span className="rounded-e-0 inline-flex items-center rounded-s-md border border-e-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-600 dark:text-gray-400">
              <svg
                className="h-6 w-5 text-blue-800 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12.4472 2.10557c-.2815-.14076-.6129-.14076-.8944 0L5.90482 4.92956l.37762.11119c.01131.00333.02257.00687.03376.0106L12 6.94594l5.6808-1.89361.3927-.13363-5.6263-2.81313ZM5 10V6.74803l.70053.20628L7 7.38747V10c0 .5523-.44772 1-1 1s-1-.4477-1-1Zm3-1c0-.42413.06601-.83285.18832-1.21643l3.49538 1.16514c.2053.06842.4272.06842.6325 0l3.4955-1.16514C15.934 8.16715 16 8.57587 16 9c0 2.2091-1.7909 4-4 4-2.20914 0-4-1.7909-4-4Z" />
                <path d="M14.2996 13.2767c.2332-.2289.5636-.3294.8847-.2692C17.379 13.4191 19 15.4884 19 17.6488v2.1525c0 1.2289-1.0315 2.1428-2.2 2.1428H7.2c-1.16849 0-2.2-.9139-2.2-2.1428v-2.1525c0-2.1409 1.59079-4.1893 3.75163-4.6288.32214-.0655.65589.0315.89274.2595l2.34883 2.2606 2.3064-2.2634Z" />
              </svg>
            </span>
            <input
              type="text"
              id="studentName"
              className="block w-full min-w-0 flex-1 rounded-none rounded-e-lg border 
              border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500  dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 
              dark:focus:ring-blue-500"
               name="from_student_name"
              onChange={handleChange}
              placeholder="Student Name"
              required
            />
          </div>
          <div className="ml-20 mr-30 mt-1 flex ">
            {errors.studentName && <p className="text-red-500 text-xs mt-1">{errors.studentName}</p>}
          </div>

          <div className="mb-2 ml-20 mr-20 mt-8 flex ">
            <span className="rounded-e-0 inline-flex items-center rounded-s-md border border-e-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900 dark:border-gray-600 dark:bg-gray-600 dark:text-gray-400">
              <svg
                className="h-4 w-5 text-blue-800 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
              </svg>
            </span>
            <input
              type="text"
              id="website-admin"
              className="block w-full min-w-0 flex-1 rounded-none rounded-e-lg border 
              border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500  dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 
              dark:focus:ring-blue-500"
               name="from_parent_name"
              onChange={handleChange}
              placeholder="Parent/Guardian Name"
              required
            />
          </div>
         <div className="ml-20 mr-30 mt-1 flex ">
             {errors.parentName && <p className="text-red-500 text-xs mt-1">{errors.parentName}</p>}
          </div>
          <div className="relative mb-2 ml-20 mr-20 mt-8">
            <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3.5">
              <svg
                className="h-6 w-4 text-blue-800 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 16"
              >
                <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
                <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
              </svg>
            </div>
            <input
              type="email"
              id="input-group-1"
              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 ps-10 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500  dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
              placeholder="name@apex.com"
              name="from_email"
              onChange={handleChange}
              required
            />
            
          </div>
          <div className="ml-20 mr-30 mt-1 flex ">
             {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
          </div>
          <div className="relative mb-2 ml-20 mr-20 mt-8">
            <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3.5">
              <svg
                className="h-6 w-4 text-blue-800 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Zm12 12V5H7v11h10Zm-5 1a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <input
              type="tel"
              id="phoneNumberCustom"
              placeholder="(555) 555-5555"
              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 ps-10 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500  dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
              value={phoneValue}
              name="phone"
              onChange={handlePhoneChange}
              required
            />
          </div>
           <div className="ml-20 mr-30 mt-1 flex ">
             {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
          </div>
          <div className="relative mb-2 ml-20 mr-20 mt-8">
            <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3.5">
              <svg
                className="h-6 w-4 text-blue-800 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 20v-9l-4 1.125V20h4Zm0 0h8m-8 0V6.66667M16 20v-9l4 1.125V20h-4Zm0 0V6.66667M18 8l-6-4-6 4m5 1h2m-2 3h2"
                />
              </svg>
            </div>
            <select
              id="grade"
              name="grade"
              //value={formData.grade}
              onChange={handleChange}
              required
              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 ps-10 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500  dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
            >
              <option value="">Select Grade</option>
              <option value="5">Grade 5</option>
              <option value="6">Grade 6</option>
              <option value="7">Grade 7</option>
              <option value="8">Grade 8</option>
              <option value="9">Grade 9</option>
              <option value="10">Grade 10</option>
              <option value="11">Grade 11</option>
              <option value="12">Grade 12</option>
            </select>
          </div>
         <div className="ml-20 mr-30 mt-1 flex ">
             {errors.grade && <p className="text-red-500 text-xs mt-1">{errors.grade}</p>}
          </div>
          <div className="relative mb-6 ml-20 mr-20 mt-8"></div>

          {/*Button */}
          <div className="mt-6 flex justify-center">
            <button
              type="button"
              onClick={handleSubmit}
              className="
              rounded-md bg-indigo-800 px-4 py-2 font-semibold text-white shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Submit Consultation Request
            </button>
          </div>
        </form>
      </div>
    </Card>
  );
}

export default Notification;
